// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const MimeTypes: MarkdocTagRegistration = {
  tag: 'mime-types',
  children: [],
  component: 'MimeTypes',
  attributes: {
    list: {
      type: Array,
      required: true,
      description: 'List of MIME type objects',
    },
  },
  description: 'MIME types table for the /docs/file-upload page',
};
